<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="subpage product-detail flex-column-start" ref="productRef">
    <Header v-if="$route.query.platform !== 'mini'" title="积分兑换" :is-sub-page="true" ref="navBarRef"></Header>

    <div class="content"  ref="contentRef" style="flex: 1; overflow:hidden; background-color: #f7f7f7;">
      <div ref="scrollRef" style="overflow-y: auto; overflow-x: hidden; height: 100%;">
        <img v-if="coverUrl" class="product-image" :src="coverUrl"/>
        <div v-else class="product-image" style="display: flex; justify-content: center; align-items: center;">暂无图片</div>

        <section class="product-info">
          <div class="name">{{this.title}}</div>
          <div class="integral">{{this.value}}积分</div>
        </section>
        <div class="tip">吉品详情</div>
        <div class="product-desc ql-snow">
          <div class="h5-web ql-editor" v-html="this.content"></div>
        </div>
      </div>>
    </div>

    <cube-button class="bottom-btn half-safe-padding" :primary="true" ref="buttonRef" @click="gotoExchange">
      立即兑换
    </cube-button>
  </div>
</template>

<script>
import Header from '@/components/Header'
import { queryGoodsDetail } from '@/api/shop'

export default {
  name: 'ProductDetail',
  components: {
    Header
  },
  data () {
    return {
      id: '',
      title: '',
      coverUrl: '',
      value: '',
      content: ''
    }
  },
  mounted () {
    console.log('id=' + this.$route.params.id)
    if (this.$route.query && this.$route.query.token) {
      this.$store.commit('setInfo', { token: this.$route.query.token })
    }
    this.id = this.$route.params.id

    this.getData()
  },
  methods: {
    getData () {
      queryGoodsDetail({
        goodsId: parseInt(this.$route.params.id)
      }).then((res) => {
        this.title = res.data.name
        this.coverUrl = res.data.cover.resUrl
        this.value = res.data.value
        this.content = res.data.detail
      })
    },

    gotoExchange () {
      this.$router.push({
        path: `/Order/${this.id}`,
        query: {
          platform: this.$route.query.platform,
          token: this.$route.query.token
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .product-detail
    .product-image
      height 375px
      width 100%
      object-fit cover
    .product-info
      margin-top 5px
      height 81px
      width 100%
      display flex
      flex-direction column
      justify-content flex-start
      background-color white
      padding-left 10px
      .name
        font-size 18px
        display flex
        justify-content flex-start
        width 100%
        margin-top 18px
        color #363636
      .integral
        color #B8B8B8
        display flex
        justify-content flex-start
        font-size 18px
        width 100%
        margin-top:12px
    .tip
      margin-top 10px
    .product-desc
      background-color white
      width 100%
      margin-top 10px
      padding 20px 15px
      box-sizing border-box
      color #363636
      font-size 15px
      text-align justify
      line-height 22px
    .conversionButton
      width 100%;
      position fixed;
      bottom 0px;
      height 49px;
      background-color #662C85;
      z-index 12;
      display flex;
      justify-content center;
      align-items center;
      font-size 18px;
      color #FFFFFF;
</style>

<style lang="stylus">
body
  background-color #f7f7f7
</style>
